import { ManageBankUserRequest, UsersWebPageUser } from '../../../../types'

export const getFormFromTableItem = (item: UsersWebPageUser): ManageBankUserRequest => {
  const { id, firstName, lastName, email, phone, assignedRelationships, role } = item

  return {
    id,
    firstName,
    lastName,
    email,
    phone,
    assignedCompaniesIds: assignedRelationships.map((relationship) => relationship.id),
    role: role.key
  }
}
